import { Abstrap } from '..';

const { propTypes } = Abstrap;

const defaultProps = { ...Abstrap.defaultProps, componentClass: 'div' };

class Tab extends Abstrap {

    getClassNameSchema() {
        const {
            className,
        } = this.props;
        return [
            'c-tab',
            className,
        ];
    }

}

Tab.propTypes = propTypes;

Tab.defaultProps = defaultProps;

export default Tab;
